import React from 'react';

import NationalContactsContentItem from './NationalContactsContentItem';
import { ContactTypes, ContactTypesShort } from './NationalContactsTypeSelect';

const SameContactsMessage = {};
SameContactsMessage[ContactTypes[1]] = `The national point of contact for ${ContactTypesShort[1]} and ${ContactTypesShort[2]} are the same.`;
SameContactsMessage[ContactTypes[2]] = `The national point of contact for ${ContactTypesShort[2]} and ${ContactTypesShort[1]} are the same.`;

export default class NationalContactsContent extends React.Component {
  renderContactItems() {
    const data = this.props.data,
      currentTypes = this.props.type ? [this.props.type] : ContactTypes;

    let PoAasITI = data[ContactTypes[2]]['same as poa'];

    return currentTypes.map((item, index) => {
      let sameMessage;
      if (PoAasITI) {
        sameMessage = SameContactsMessage[item];
      }

      return (
        <NationalContactsContentItem
          key={ index }
          section={ item }
          content={ data[item] }
          sameMessage={ sameMessage }
        />
      );
    });
  }

  render() {
    return (
      <div className={ this.props.className }>
        { this.renderContactItems() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NationalContacts/NationalContactsContentList.js